{
  "version": 1,
  "asset_id": "b06f9046-8e45-49b3-be4c-d1d9e36b1378",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/b06f9046-8e45-49b3-be4c-d1d9e36b1378/ctrs.webp",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/b06f9046-8e45-49b3-be4c-d1d9e36b1378/ctrs.webp",
  "original_filename": "ctrs.webp",
  "size": 13748,
  "content_type": "image/webp",
  "created_at": "2026-06-26T16:55:00Z"
}
